import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ShipmentTransportOrderNotificationsFacade } from './shipment-transport-order-notifications.facade';
import { TransportOrderIdView } from '../../../../models';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ShipmentTransportOrderItemFacade } from '../shipment-transport-order-item.facade';

@Injectable({ providedIn: 'root' })
export class ShipmentTransportOrderNotificationsGuard {
  constructor(
    private shipmentTransportOrderNotificationsFacade: ShipmentTransportOrderNotificationsFacade,
    private shipmentTransportOrderItemFacade: ShipmentTransportOrderItemFacade,
  ) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return this.shipmentTransportOrderItemFacade.shipmentTransportOrderIdentifier$.pipe(
      switchMap((identifier: TransportOrderIdView) => {
        this.shipmentTransportOrderItemFacade.loadShipmentTransportOrderNotificationListCount(identifier);

        return loadStoreState(this.shipmentTransportOrderNotificationsFacade, identifier);
      }),
    );
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentTransportOrderNotificationsFacade);
  }
}
